import { OrderLoyaltyReward } from '@eliadmin/core/src/components/loyalty/order-loyalty-reward';
import { ProfileRepeatOrderButton } from '@eliadmin/core/src/components/profile/profile-repeat-order-button';
import type { CustomerOrder } from '@eliadmin/core/src/api/customers/customers-types';

import { ProfileOrderDialog } from '@eliadmin/core/src/components/profile/profile-order-dialog';
import { ProfileOrderStatus } from '@eliadmin/core/src/components/profile/profile-order-status';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { Card, CardContent } from '@eliadmin/core/src/components/ui/card';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { formatDateOrder } from '../../utils/format-date-order';
import { Modal } from '../ui/modal';
import { ProfileOrderDialogContent } from './profile-order-dialog-content';

export type ProfileOrderItemProps = {
  order: CustomerOrder;
};

//
export function ProfileOrderItem(props: ProfileOrderItemProps) {
  const locale = useLocaleStore(s => s.currentLocale);
  const currency = useGlobalStore(s => s.generalLayout.currency);

  const { t } = useTranslations();

  const labelPhoneClassName = 'text-sm font-semibold text-muted';

  return (
    <Card className="w-full rounded-[4px] border border-border bg-transparent">
      <CardContent className="hidden flex-row items-center justify-start gap-8 p-4 lg:flex">
        <span className="w-full max-w-[130px] text-start font-semibold text-black">
          #{props.order.identifier}
        </span>
        <span className="w-full min-w-[140px] max-w-[140px] whitespace-nowrap text-sm font-normal text-black">
          {formatDateOrder(props.order.created_at)}
        </span>
        <span className="w-full min-w-[111px] max-w-[111px] text-start font-normal text-black">
          {props.order.price.toFixed(2)} {currency}
        </span>
        <div className="flex w-full max-w-[120px] flex-row justify-start">
          <ProfileOrderStatus order={props.order} />
        </div>
        <Modal
          title={t(`${t('text3414')} #${props.order.identifier}`)}
          className={{ content: 'flex flex-col items-start justify-start gap-6 p-6' }}
          showCustomClose
          trigger={
            <div className="flex w-full items-end justify-end">
              <Button variant={'dark'} className="w-full whitespace-nowrap sm:w-fit">
                {t('text116')}
              </Button>
            </div>
          }
        >
          <ProfileOrderDialogContent order={props.order} />
        </Modal>
      </CardContent>
      <CardContent className="flex flex-col items-start justify-start gap-4 rounded-[4px] bg-transparent p-4 lg:hidden">
        <div className="flex w-full flex-col items-start justify-start gap-2">
          <div className="flex w-full items-center justify-between">
            <p className={cn(labelPhoneClassName)}>{t('text305')}</p>
            <p className="text-sm font-semibold text-black sm:text-base">
              #{props.order.identifier}
            </p>
          </div>
          <div className="flex w-full items-center justify-between">
            <p className={cn(labelPhoneClassName)}>{t('text393')}:</p>
            <p className="text-sm font-normal text-black sm:text-base">
              {new Date(props.order.created_at).toLocaleString(locale)}
            </p>
          </div>
          <div className="flex w-full items-center justify-between">
            <p className={cn(labelPhoneClassName)}>{t('text26')}:</p>
            <p className="text-sm font-normal text-black sm:text-base">
              {props.order.price.toFixed(2)} {currency}
            </p>
          </div>
          <div className="flex w-full items-center justify-between">
            <p className={cn(labelPhoneClassName)}>{t('text245')}:</p>
            <p className="text-sm font-normal text-black sm:text-base">
              <ProfileOrderStatus order={props.order} />
            </p>
          </div>
        </div>
        <Modal
          title={t(`${t('text3414')} #${props.order.identifier}`)}
          showCustomClose
          className={{ content: 'flex flex-col items-start justify-start gap-6' }}
          trigger={
            <div className="flex w-full">
              <Button variant={'dark'} className="w-full whitespace-nowrap">
                {t('text116')}
              </Button>
            </div>
          }
        >
          <ProfileOrderDialogContent order={props.order} />
        </Modal>
      </CardContent>
      <ProfileRepeatOrderButton
        orderId={props.order.id}
        className="mx-4 mb-4 sm:ml-auto sm:max-w-sm"
      />

      <OrderLoyaltyReward
        reward={props.order.loyalty_reward}
        compact
        className="w-full px-4 pb-4"
      />
    </Card>
  );
}
